import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import MissionVisionValues from '../components/servicemission';

const Landing2about = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div style={{ backgroundColor: "#f3f4f6", padding: '16px' }} id="about">
      <Box
        sx={{
          bgcolor: '#f3f4f6',
          borderRadius: 2,
          overflow: 'hidden',
          p: { xs: 2, sm: 3, md: 4 },
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column-reverse', md: 'row' },
            alignItems: 'center',
            gap: { xs: 4, md: 6 },
          }}
        >
          {/* Right Content - Photos Section */}
          <Box
            sx={{
              flex: '1',
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: { xs: '300px', sm: '400px', md: '500px' },
              width: '100%',
            }}
          >
            {/* Large Zig-Zag Photo */}
            <Box
              sx={{
                position: 'relative',
                width: { xs: '80%', sm: '60%', md: '400px' },
                height: { xs: '250px', sm: '350px', md: '450px' },
                maxWidth: '100%',
                clipPath: 'polygon(20% 0, 80% 0, 100% 15%, 100% 85%, 80% 100%, 20% 100%, 0 85%, 0 15%)',
                bgcolor: '#e8f5e9',
                overflow: 'hidden',
                boxShadow: 3,
              }}
            >
              <img
                src="b-a.jpg"
                alt="Scientists working in laboratory"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>

            {/* Small Zig-Zag Photo */}
            <Box
              sx={{
                position: 'absolute',
                bottom: '10%',
                right: { xs: '10%', md: '5%' },
                width: { xs: '80px', sm: '120px', md: '150px' },
                height: { xs: '80px', sm: '120px', md: '150px' },
                clipPath: 'polygon(20% 0, 80% 0, 100% 15%, 100% 85%, 80% 100%, 20% 100%, 0 85%, 0 15%)',
                bgcolor: 'white',
                p: 0.5,
                zIndex: 2,
                boxShadow: 2,
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  clipPath: 'polygon(20% 0, 80% 0, 100% 15%, 100% 85%, 80% 100%, 20% 100%, 0 85%, 0 15%)',
                  overflow: 'hidden',
                }}
              >
                <img
                  src="2148498996.jpg"
                  alt="Researchers in lab"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            </Box>

            {/* Zig-Zag Experience Badge */}
            <Box
              sx={{
                position: 'absolute',
                top: '10%',
                left: { xs: '10%', md: '5%' },
                width: { xs: 80, sm: 110, md: 140 },
                height: { xs: 80, sm: 110, md: 140 },
                clipPath: 'polygon(20% 0, 80% 0, 100% 15%, 100% 85%, 80% 100%, 20% 100%, 0 85%, 0 15%)',
                bgcolor: '#234152',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                zIndex: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  mb: 0.5,
                  fontSize: { xs: '1rem', sm: '1.2rem' }, // Increased mobile font size
                }}
              >
                11+
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  textAlign: 'center',
                  lineHeight: 1.2,
                  px: 1,
                  fontSize: { xs: '0.75rem', sm: '0.8rem' }, // Increased mobile font size
                }}
              >
                years of experience
              </Typography>
            </Box>
          </Box>

          {/* Left Content */}
          <Box
            sx={{
              flex: '1',
              textAlign: { xs: 'center', md: 'left' },
              px: { xs: 2, sm: 3 },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', md: 'flex-start' },
                alignItems: 'center',
                gap: 1,
                mb: 2,
                color: '#f97316',
              }}
            >
              <Typography
                variant="button"
                sx={{
                  fontWeight: 600,
                  letterSpacing: 1,
                  fontSize: { xs: '0.9rem', sm: '0.8rem' }, // Increased mobile font size
                }}
              >
                MISSION
              </Typography>
            </Box>

            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                fontSize: { xs: '1.4rem', sm: '1.55rem', md: '1.65rem' }, // Increased mobile font size
                lineHeight: 1.2,
                mb: 2,
                color: '#172554',
              }}
            >
              We help students{" "}
              <span
                style={{
                  background:
                    "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
                  padding: "0px 5px",
                }}
              >
                achieve academic
              </span>{" "}
              excellence.
            </Typography>

            <Typography
              sx={{
                color: 'black',
                mb: 4,
                lineHeight: 1.8,
                fontSize: { xs: '0.95rem', sm: '0.9rem', md: '1rem' }, // Increased mobile font size
              }}
            >
              Our mission is to provide high-quality, plagiarism-free assignment writing services that help students succeed academically. We aim to assist students in achieving their academic goals by offering personalized writing support for essays, research papers, dissertations, and more.
            </Typography>

            <Box>
              <MissionVisionValues />
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Landing2about;